import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './present-perfect-continuous-explanation';

const mainimage = '/Images/present-perfect-continuous.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "present-perfect-continuous" },
];

const PresentPerfectContinuous = () => (
  <GrammarPageLayout
    level="B1"
    title="Present Perfect Continuous"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Present Perfect Continuous Exercises"
    seoDescription="Practice the present perfect continuous tense with have/has been + verb-ing forms. B1 level grammar exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default PresentPerfectContinuous;